import React, { useState } from "react";
import { Sparkles, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PageContainer, PageHeader } from "@/components/Page";

const VFBatch = () => {
  const [topics, setTopics] = useState(["", ""]);
  const [created, setCreated] = useState([]);
  const [loading, setLoading] = useState(false);

  const update = (i, val) => setTopics((t) => t.map((x, idx) => idx === i ? val : x));
  const add = () => setTopics([...topics, ""]);
  const remove = (i) => setTopics(topics.filter((_, idx) => idx !== i));

  const submit = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/video-factory/batch", { topics: topics.filter(t => t.trim()), platforms: ["YouTube", "Instagram Reels"] });
      setCreated(data.created || []);
      toast.success(`${data.queued} videos queued`);
    } catch (e) { toast.error("Failed to queue"); }
    finally { setLoading(false); }
  };

  return (
    <PageContainer>
      <PageHeader title="Batch Mode" subtitle="Queue 5-10 videos and generate them all in one go." testId="vf-batch-header" />
      <div className="max-w-2xl mx-auto">
        <div className="op-card p-6 mb-5">
          <h3 className="font-semibold text-gray-900 mb-4">Topics</h3>
          <div className="space-y-2">
            {topics.map((t, i) => (
              <div key={i} className="flex gap-2">
                <input value={t} onChange={(e) => update(i, e.target.value)} placeholder={`Topic ${i + 1}`} className="op-input flex-1" data-testid={`batch-topic-${i}`} />
                {topics.length > 1 && <button onClick={() => remove(i)} className="op-btn-secondary px-3"><X size={16} /></button>}
              </div>
            ))}
          </div>
          <button onClick={add} className="op-btn-secondary mt-3 text-sm">+ Add another topic</button>
        </div>
        <button onClick={submit} disabled={loading} className="op-btn-primary mx-auto" data-testid="batch-submit"><Sparkles size={16} /> {loading ? "Queueing..." : "Queue all videos →"}</button>
      </div>

      {created.length > 0 && (
        <div className="mt-10 max-w-3xl mx-auto">
          <h3 className="font-bold text-gray-900 mb-4">Queue progress</h3>
          {created.map((v) => (
            <div key={v.id} className="op-card p-4 mb-2 flex items-center justify-between" data-testid={`batch-row-${v.id}`}>
              <p className="font-medium">{v.topic}</p>
              <span className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs font-medium animate-pulse">Generating...</span>
            </div>
          ))}
        </div>
      )}
    </PageContainer>
  );
};
export default VFBatch;
